const locale = {
  placeholder: '请选择',
  searchPlaceholder: '搜索',
  // FunctionSelectField
  functionPlaceholder: '请选择职能',
  functionSearchPlaceholder: '搜索职能',
  // IndustrySelectField
  industryPlaceholder: '请选择行业',
  industrySearchPlaceholder: '搜索行业',
  // AddressSelectField
  addressPlaceholder: '请选择城市',
  addressSearchPlaceholder: '搜索城市',
  domestic: '国内',
  abroad: '国外'
};

export default locale;
